export default "__VITE_ASSET__c51c6b50__"